import React, { useState, useEffect, useContext } from 'react';
import FilterPill from '../filters/FilterPill';
import './ScrollSpy.css';
import scrollContext from '../../context/scroll/scrollContext';
import cardContext from '../../context/cards/cardContext';
import icons from '../icons/Icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ScrollSpy = ({ filterList }) => {
    const [activeId, setActiveId] = useState(filterList[0]?.id);
    const { visible } = useContext(scrollContext);
    const { searchTerm, handleSearch, clearSearch } = useContext(cardContext);
    const [isSearchExpanded, setIsSearchExpanded] = useState(false);

    const handlePillClick = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
            setActiveId(id);
        }
    };

    const handleSearchClick = () => {
        setIsSearchExpanded(true);
    };

    const handleSearchClose = () => {
        setIsSearchExpanded(false);
        clearSearch();
    };

    const handleSearchChange = (e) => {
        handleSearch(e.target.value);
    };

    const handleScroll = () => {
        filterList.forEach(({ id }) => {
            const section = document.getElementById(id);
            if (section) {
                const rect = section.getBoundingClientRect();
                if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
                    setActiveId(id);
                }
            }
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [filterList]);

    return (
        <div className={`scroll-spy-container ${visible ? 'scrollspy-visible' : 'scrollspy-hidden'}`}>
            <div className="scroll-spy">
                {!isSearchExpanded ? (
                    <>
                        {/* Search icon button */}
                        <button className="search-icon-button" onClick={handleSearchClick}>
                            <FontAwesomeIcon icon={icons.search} />
                        </button>
                        
                        {/* Filter pills */}
                        <div className="scrollspy-content">
                            {filterList.map(({ id, name, icon }) => (
                                <FilterPill
                                    key={id}
                                    name={name}
                                    icon={icon}
                                    isActive={activeId === id}
                                    onClick={() => handlePillClick(id)}
                                />
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        {/* Back button */}
                        <button className="back-button" onClick={handleSearchClose}>
                            <i className="fas fa-arrow-left"></i>
                        </button>
                        
                        {/* Expanded search input */}
                        <input 
                            type="text" 
                            className="expanded-search-input" 
                            placeholder="Search for dishes..." 
                            value={searchTerm} 
                            onChange={handleSearchChange}
                            autoFocus
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default ScrollSpy;
